import React from "react";

/**
 * MetricsGrid Component
 * Displays a grid of metric cards showing company KPIs
 * Props:
 * - metrics: Array of metric objects with { icon, label, value }
 */
export default function MetricsGrid({ metrics = [] }) {
  return (
    <div className="cd-metrics-grid">
      {metrics.map((m, i) => (
        <div key={i} className="cd-metric-card">
          <div className="cd-metric-header">
            <span className="cd-metric-icon">{m.icon}</span>
            <span className="cd-metric-label">{m.label}</span>
          </div>
          <div className="cd-metric-value">{m.value}</div>
        </div>
      ))}
    </div>
  );
}
